import axios from "axios";

/**
 * Single session token in localStorage — no refresh tokens.
 * Cleared only on manual logout (clearAuthToken).
 */
export const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  if (!token || token === "null" || token === "undefined") return null;
  if (token.split(".").length !== 3) return null;
  return token;
};

export const setAuthToken = (token) => {
  if (!token || typeof token !== "string" || token.split(".").length !== 3) {
    localStorage.removeItem("authToken");
    return;
  }
  localStorage.setItem("authToken", token);
};

export const clearAuthToken = () => {
  localStorage.removeItem("authToken");
};

axios.interceptors.request.use((config) => {
  const url = String(config.url || "");
  const isLoginRequest = url.includes("/login") && !url.includes("logout");
  const token = getAuthToken();

  if (!isLoginRequest && token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});
